import React, { useState } from "react";

import {
  Box,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text
} from "@chakra-ui/react";

export interface AddSenderProps {
  isOpen: boolean;
  onClose: () => void;
  senderType: "ALLOWED" | "REJECTED" | "BLOCKED";
  isLoading?: boolean;
  onAddSender: (data: {
    full_name: string;
    email: string;
    position: string;
    status: string;
  }) => void;
}

export const AddSender: React.FC<AddSenderProps> = ({
  isOpen,
  onClose,
  senderType,
  isLoading,
  onAddSender
}) => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    position: ""
  });

  const getTitle = () => {
    switch (senderType) {
      case "ALLOWED":
        return "Add Safe Sender";
      case "REJECTED":
        return "Add Revoked Sender";
      case "BLOCKED":
        return "Add Blocklisted Sender";
      default:
        return "Add Sender";
    }
  };

  const handleSubmit = () => {
    onAddSender({
      ...formData,
      status: senderType
    });
    setFormData({
      full_name: "",
      email: "",
      position: ""
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          fontSize="20px"
          fontWeight="600"
          borderBottom="1px solid #E0E0E0"
        >
          {getTitle()}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <Box>
              <Text mb={2} fontSize="14px" fontWeight="500">
                Full Name
              </Text>
              <Input
                value={formData.full_name}
                onChange={(e) =>
                  setFormData({ ...formData, full_name: e.target.value })
                }
                placeholder="Enter full name"
                size="lg"
              />
            </Box>
            <Box>
              <Text mb={2} fontSize="14px" fontWeight="500">
                Email
              </Text>
              <Input
                type="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                placeholder="Enter email address"
                size="lg"
              />
            </Box>
            <Box>
              <Text mb={2} fontSize="14px" fontWeight="500">
                Position
              </Text>
              <Input
                value={formData.position}
                onChange={(e) =>
                  setFormData({ ...formData, position: e.target.value })
                }
                placeholder="Enter position"
                size="lg"
              />
            </Box>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            size="lg"
            isDisabled={isLoading}
            border="1px solid #E0E0E0"
          >
            Cancel
          </Button>
          <Button
            colorScheme="primary"
            onClick={handleSubmit}
            isLoading={isLoading}
            size="lg"
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
